<template>
  <NavButton class="bg-light-purple-nav btn-bg">
    <span class="flex items-center gap-2 text-white dark:bg-dark-blue">
      <slot />
    </span>
  </NavButton>
</template>

<style scoped>
.dark .btn-bg{
  background-color: #191D23 !important;
}
</style>
